import { ERoutePaths } from '@/types';
import { EBotNamesBackend } from '@/types/botConfigTypes';

/**
 * URL segment -> backend bot.
 *
 * These are deliberately separate value spaces: route paths are a native-facing
 * contract (what the shell opens), bot names are an API contract (what Policy
 * GPT receives). Keeping the mapping explicit means changing a flow's bot is a
 * one-line edit here rather than a hunt for hardcoded strings.
 *
 * Everything resolves to speciality-match today; match-therapist-v2 gets its
 * own bot in a later change.
 */
export const ROUTE_BOT_NAME_MAP: Record<string, EBotNamesBackend> = {
  [ERoutePaths.MATCH_SPECIALIST]: EBotNamesBackend.SPECIALITY_MATCH,
  [ERoutePaths.MATCH_THERAPIST]: EBotNamesBackend.SPECIALITY_MATCH,
  // TODO: replace with the v2 bot once the backend provides it.
  [ERoutePaths.MATCH_THERAPIST_V2]: EBotNamesBackend.THERAPIST_MATCH,
};

/**
 * Resolves the bot for a URL's first path segment. Anything unmapped — `/`,
 * an unknown segment, or no segment at all — falls back to speciality-match,
 * so an unregistered route degrades to the default flow rather than failing.
 */
export const getBotNameFromRoute = (
  routeSegment?: string,
): EBotNamesBackend =>
  (routeSegment && ROUTE_BOT_NAME_MAP[routeSegment]) ||
  EBotNamesBackend.SPECIALITY_MATCH;
